export var PurchaseOrderItemType;
(function (PurchaseOrderItemType) {
    PurchaseOrderItemType[PurchaseOrderItemType["PURCHASE"] = 1] = "PURCHASE";
    PurchaseOrderItemType[PurchaseOrderItemType["MISC_PURCHASE"] = 2] = "MISC_PURCHASE";
    PurchaseOrderItemType[PurchaseOrderItemType["FREIGHT"] = 3] = "FREIGHT";
    PurchaseOrderItemType[PurchaseOrderItemType["CREDIT_RETURN"] = 4] = "CREDIT_RETURN";
    PurchaseOrderItemType[PurchaseOrderItemType["MISC_CREDIT"] = 5] = "MISC_CREDIT";
    PurchaseOrderItemType[PurchaseOrderItemType["TAX"] = 6] = "TAX";
    PurchaseOrderItemType[PurchaseOrderItemType["NOTE"] = 7] = "NOTE";
})(PurchaseOrderItemType || (PurchaseOrderItemType = {}));
//# sourceMappingURL=purchase-order-item-type.js.map